export default __webpack_public_path__ + "static/media/clapping@3x.4ff14382.png";